<template>
  <div class="weekday-toggle pcs-toggles" role="group">
    <button
      v-for="wd in weekdayOptions"
      :key="wd.id"
      type="button"
      :class="'btn btn-sm ' + (modelValue.includes(wd.id) ? 'btn-success' : 'btn-default')"
      :aria-pressed="modelValue.includes(wd.id) ? 'true' : 'false'"
      :disabled="disabled"
      v-on:click="toggle(wd.id)"
    >
      {{ wd.short }}
    </button>
  </div>
</template>

<script>
const ALL = ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su']

// Weekday filter of the price calendars' date range form (v-model: ['mo', ...]). With every day on,
// a click picks only that day; clicking the only picked day turns every day back on.
export default {
  props: {
    modelValue: { type: Array, default: () => ALL.slice() },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  computed: {
    weekdayOptions () {
      return ALL.map(id => ({ id, short: this._(id) }))
    }
  },
  methods: {
    toggle (id) {
      const days = this.modelValue
      if (days.length === ALL.length) {
        this.$emit('update:modelValue', [id])
        return
      }
      if (days.length === 1 && days[0] === id) {
        this.$emit('update:modelValue', ALL.slice())
        return
      }
      const next = days.includes(id) ? days.filter(d => d !== id) : days.concat([id])
      this.$emit('update:modelValue', ALL.filter(d => next.includes(d)))
    }
  }
}
</script>
